import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { toast } from 'vue-sonner';
import { Api } from '@/api';
import type { WorkflowTemplateKey } from '@/api/entity_types/workflow/WorkflowTemplate';

export const useCreateFromTemplate = () => {
  const router = useRouter();
  const creatingKey = ref<WorkflowTemplateKey | null>(null);

  const selectTemplate = async (key: WorkflowTemplateKey) => {
    if (creatingKey.value) return;
    creatingKey.value = key;

    const response = await Api.WorkflowTemplates.createFromTemplate(key);

    if (response.status === 'success') {
      toast.success('Workflow Created', { description: 'Your workflow was created from the template and is enabled.' });
      router.push({ name: 'WorkflowDetail', params: { id: response.data.id } });
    } else {
      creatingKey.value = null;
      const description = response.messages?.join(', ') || 'An error occurred while creating the workflow.';
      toast.error('Error Creating Workflow', { description });
    }
  };

  return {
    creatingKey,
    selectTemplate,
  };
};
